module.exports = __webpack_public_path__ + "media/images/athletes/1493-d57bddd51c4e999917afea440c976afb.png";